import { v4 } from 'uuid';

export type TimeListRuntimeState =
    | { type: 'initializing' }
    | { type: 'error'; error: Error }
    | { type: 'waiting-for-symbols'; instanceId: string }
    | { type: 'ready'; instanceId: string; symbols: Set<string> };

export const componentFailed = (error: Error) => ({ type: 'COMPONENT_FAILED', error }) as const;

export type TimeListRuntimeAction =
    | ReturnType<typeof componentFailed>
    | { type: 'INITIALIZE_SUCCESS' }
    | { type: 'SOURCE_CHANGED' }
    | { type: 'SYMBOLS_SNAPSHOT_RECEIVED'; symbols: Iterable<string> }
    | { type: 'SYMBOLS_UPDATE_RECEIVED'; added: Iterable<string>; removed: Iterable<string> };

/** Transient widget lifecycle. Persisted configuration lives separately on the model. */
export function timeListRuntimeReducer(
    state: TimeListRuntimeState,
    action: TimeListRuntimeAction,
): TimeListRuntimeState {
    // A late initialization or membership update must not revive a crashed component.
    if (state.type === 'error') return state;
    switch (action.type) {
        case 'COMPONENT_FAILED':
            return { type: 'error', error: action.error };
        case 'INITIALIZE_SUCCESS':
            return { type: 'waiting-for-symbols', instanceId: v4() };
        case 'SOURCE_CHANGED':
            return state.type === 'ready' ? { type: 'waiting-for-symbols', instanceId: v4() } : state;
        case 'SYMBOLS_SNAPSHOT_RECEIVED':
            return state.type === 'initializing'
                ? state
                : { ...state, type: 'ready', symbols: new Set(action.symbols) };
        case 'SYMBOLS_UPDATE_RECEIVED': {
            if (state.type !== 'ready') return state;
            const symbols = new Set(state.symbols);
            for (const symbol of action.removed) symbols.delete(symbol);
            for (const symbol of action.added) symbols.add(symbol);
            return { ...state, symbols };
        }
    }
}
